import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Response } from '../../shared/models/response.model';
import { Modalité } from '../models/modalité.model';
import { ModalitéCreateRequest } from '../requests/modalité-create-request.model';
import { ModalitéUpdateRequest } from '../requests/modalité-update-request.model';

@Injectable({
  providedIn: 'root',
})
export class ModalitéService {
  #http = inject(HttpClient);
  readonly BASE_URL = '/modalités';

  trouveParId = (id: string) => this.#http.get<Modalité>(this.BASE_URL + '/' + id);

  trouverTous = (idCartographie: string) =>
    this.#http.get<Response<Modalité>>(this.BASE_URL, { params: { idCartographie } });

  ajouter = (data: ModalitéCreateRequest) => this.#http.post<void>(this.BASE_URL, data);

  modifier = (id: string, data: ModalitéUpdateRequest) => this.#http.put<void>(this.BASE_URL + '/' + id, data);

  supprimer = (id: string) => this.#http.delete(this.BASE_URL + '/' + id);
}
